<template>
<div class="file-viewer-container" :style="`height: ${height}; width: ${width};`" v-if="fileList.length > 0 && activeFile">
    <span class="file-viewer-button"  v-if="fileList.length > 1" @click="previous">
        <i class="fas fa-chevron-left"></i>
    </span>
    <div class="file-viewer-file" v-if="activeFileExtension">
        <template v-if="fileTypeIs('audio', activeFileExtension)">
            <ks-audio-player :url="activeFileSource"> </ks-audio-player>
        </template>
        <template v-else-if="fileTypeIs('video', activeFileExtension)">
            <ks-video-player :url="activeFileSource" width="100%" heigth="100%" > </ks-video-player>
        </template>
        <template v-else-if="fileTypeIs('image', activeFileExtension)">
            <img :src="activeFileSource">
        </template>
        <template v-else>
            <iframe frameborder="0" scrolling="no" :style="`height: 100% ; width: 100%;`" :src="activeFileSource"></iframe> 
        </template>
    </div>
    <span class="file-viewer-button" v-if="fileList.length > 1" @click="next">
        <i class="fas fa-chevron-right"></i>
    </span>
</div>
</template>
        
<script>
import fileTypeIs from '../../mixins/fileTypeIs';
export default {
    /**
        tag
        name: ks-file-viewer
        description: file viewer 
    **/
    name: "ks-file-viewer",
    mixins: [fileTypeIs],
    props: {
        /**
            attribute
            name: width 
            description: width
        **/
        width:{
            type: String,
            default: '100%'
        },
        /**
            attribute
            name: height 
            description: height
        **/
        height:{
            type: String,
            default: '100%'
        },
        /**
            attribute
            name: files 
            description: files
        **/
        files: {
            type: Array,
            default: () => [] // [src:"....", "file_name": "...."] or [src]
        },
        defaultFilters:{
            type: Object,
            default: null
        },
        /**
            attribute
            name: selectedIndex 
            description: selectedIndex
        **/
        defaultFileIndex: {
            type: Number,
            default: 0
        },
        viewType:{
            type: String,
            default: 'content' //thumbnail
        }
    },
    watch: {
        files:{
            handler:function(val){
                this.loadFileList();
            },
            deep:true
        },
        defaultFilters:{
            handler:function(va){
                this.loadFileList();
            },
            depp:true,
        }
    },
    computed: {
        activeFile(){
            try{
                return this.fileList[this.currentIndex]; 
            }catch(err){
                return null;
            }
        },
        activeFileExtension(){
            if(this.activeFile){
                let fileName = this.activeFile.file_name||this.activeFile.name||null;
                return fileName?fileName.split('.').pop():null;
            }else return null;
        },
        activeFileSource(){
            return this.viewType=='content'?this.activeFile.src:this.activeFile._src;
        }
    },
    methods: {
        async loadFileList(){
            if(this.defaultFilters){
                this.isLoading = true;
                try{
                    const res = await app.data.list("file.file", this.defaultFilters);
                    const files = res.list;
                    this.fileList = files.map((file) => { return {...file, '_src':`${this.getSRCThumbnail(file, true)}`, 'src': `${app.apiURL}/file/files/${file.file_code_id||file.code_id}?token=${window.app.auth.urlToken}`} });
                    this.isLoading = false;
                }catch(err){
                    console.log(err);
                    this.isLoading = false;
                    return;
                }
            }else if(this.files){
                this.fileList = this.files.map(file => {
                    if(typeof file == 'object' )return file;
                    else return {'_src': file};
                });
            }
            this.$emit('onLoadList', this);
        },
        previous() {
            let index = this.currentIndex - 1
            if(index >= 0){
                this.currentIndex = index;
            } else{
                this.currentIndex = this.fileList.length - 1;
            }  
        },
        next(){
            let index = this.currentIndex + 1
            if(index < this.fileList.length){
                this.currentIndex = index;
            } else{
                this.currentIndex = 0;
            }
        },
        setCurrentIndex(val){
            this.currentIndex = val;
        }
    },
    mounted(){
        this.loadFileList();
    },
    data() {
        return {
            fileList: [],
            isLoading: false,
            currentIndex: this.defaultFileIndex
        }
    }
}
</script>
        
<style scoped>
.file-viewer-container
{
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    gap:10px
}
.file-viewer-file
{
    display:flex;
    justify-content:center;
    /*align-items:center;
    flex:1;*/
    height: 100%;
    width: 100%;
}
.file-viewer-button{
    width: 45px;
    height: 45px;
    background-color: #7b7b7b;
    border-radius: 50%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    cursor: pointer;
}
.file-viewer-button:hover{
    background:rgb(165, 165, 165)
}

img {
  max-width: 100%;
  max-height: 85%;
  object-fit: contain;
  display: block;
}
</style>
        